// Where the api stores uploaded media, registered in AppContainer from EnvConfiguration. Kept apart
// from it so what reads it can be unit tested: EnvConfiguration reads import.meta, which the unit
// test runner cannot load.
export class UploadsLocation {
    constructor(public baseUrl: string) {}
}
